import React from "react";
import { InlineUserInput } from "../components/inline-user-input.component";
import { HtmlMessageComponent } from "../components/html-message.component";
import { NoInputComponent } from "../components/step-components/NoInputComponent";
import { PrettyButtonGroup } from "../components/pretty-button-group.component";
import { GeoAutoComplete } from "../components/autocomplete";
import { ThumbDown, ThumbUpSharp } from "@mui/icons-material";
import getServiceEntryId from "../services/programTypes/getServiceEntryId";
import getMandatoryServiceQuestionsProgramTypes from "../services/programTypes/getMandatoryServiceQuestionsProgramTypes";
import { hasProbingQuestionsEnabled } from "../utils/utils";

export default function newCustomerOnboard(self) {
  return [
    {
      id: "new-customer-intro",
      message:
        "Hi my name is Kim... Who do I have the pleasure of speaking with?",
      trigger: "new-customer-collect-name",
    },
    {
      id: "new-customer-collect-name",
      component: (
        <InlineUserInput id="new-customer-name" placeholder={"John Smith"} />
      ),
      dispatchMessage: (val) => {
        if (val && val !== "null") {
          self.setState({ customerName: val });
          // self.recordChatRecord({customerName: val});

          // Save quote data to localStorage after updating customer name
          self.saveQuoteToLocalStorage();
        }
      },
      waitAction: true,
      trigger: "new-customer-welcome",
    },
    {
      id: "not-my-address",
      dispatchMessage: () => {
        self.setState({
          clickedNoFromContactForm: true,
        });
      },
      component: <HtmlMessageComponent />,
      inputAttributes: {
        html: `<div>
        Okay well then let me ask you some questions to make sure we get you
        the most accurate quote possible.
      </div>`,
      },
      asMessage: true,
      trigger: "no-address-phone-ask",
    },
    {
      id: "new-customer-welcome",
      message:
        "Wonderful {previousValue}!  Thanks so much for interacting with our bot",
      trigger: "new-customer-address-ask",
    },
    {
      id: "new-customer-address-ask",
      message:
        "What is the street address of the property which you would like a quote?",
      trigger: "new-customer-address-collect",
    },
    {
      id: "new-customer-address-collect",
      user: true,
      placeholder: "Enter Street Address",
      trigger: "new-customer-city-state-ask",
    },
    {
      id: "new-customer-city-state-ask",
      message: "What is the city and state of the property?",
      trigger: "new-customer-city-state-collect",
    },
    {
      id: "new-customer-city-state-collect",
      user: true,
      placeholder: "Enter City, State",
      trigger: "new-customer-lookup-start",
    },
    {
      id: "new-customer-lookup-start",
      message:
        "Perfect!  We are now going to attempt to collect data on your property...",
      trigger: "get-calculating-step",
    },
    {
      id: "getting-started",
      message: () => {
        if (self.crmSolution === "servman") {
          return "Wonderful! To schedule your service, we will need to collect some information from you.";
        }
        return "Wonderful!";
      },
      trigger: "new-customer-phone-ask-enter",
    },
    {
      id: "new-customer-phone-ask-enter",
      message: () => {
        if (self.crmSolution === "servman") {
          return "Please enter your phone number below.";
        }
        return "To start your Instant Quote please enter your complete phone number.";
      },
      trigger: "new-customer-phone-collect",
    },
    {
      id: "no-address-phone-ask",
      message:
        "I can look up your Instant Quote please enter your complete phone number.",
      trigger: "new-customer-phone-collect",
    },
    {
      id: "new-customer-phone-collect",
      asMessage: false,
      component: (
        <InlineUserInput
          id="new-customer-phone-input"
          placeholder={"Enter 10 Digit Phone Number"}
          type={"tel"}
          name={"phone"}
          maxLength={11}
          customButton={true}
          defaultInputMessage={"Send"}
          validator={(value) => {
            const check = `${value}`.length;

            // biome-ignore lint/suspicious/noGlobalIsNan: Making this Global.Nan might give unexpected results
            if (isNaN(value) || (check !== 10 && check !== 11)) {
              return "Phone number must be 10 or 11 digits";
            }
            return true;
          }}
        />
      ),
      waitAction: true,
      sendUserMessage: true,
      dispatchMessage: (value) => {
        if (value && value !== "null") {
          self.setState({
            phonenumber: value,
          });

          // Save quote data to localStorage after updating phone number
          self.saveQuoteToLocalStorage();
        }
      },
      trigger: "ask-new-customer-address",
      // trigger: "new-customer-zip-ask"
    },
    {
      id: "ask-new-customer-address",
      message: "Please enter your address.",
      trigger: () => {
        return "collect-new-customer-address";
      },
    },
    {
      id: "collect-new-customer-address",
      component: <GeoAutoComplete />,
      waitAction: true,
      asMessage: false,
      trigger: () => {
        return "process-new-customer-address";
      },
    },
    {
      id: "process-new-customer-address",
      component: (
        <NoInputComponent
          dispatchMessage={async (previousValue) => {
            const address = previousValue.value;
            if (typeof address !== "undefined" && address !== null) {
              const customerState = {
                customerAddress: `${address.houseNumber} ${address.street}`,
                customerCity: address.city,
                customerZip: address.postalCode,
                customerCounty: address.county,
                customerState: address.state,
                customerCountryCode: address.countryCode,
              };
              await self.setState(customerState);

              // Save quote data to localStorage after updating customer address
              self.saveQuoteToLocalStorage();
            }
          }}
        />
      ),
      asMessage: false,
      waitAction: true,
      trigger: () => {
        const street = self.state.customerAddress.toLowerCase();
        const city = self.state.customerCity.toLowerCase();
        const postalCode = self.state.customerZip.toLowerCase();
        const county = self.state.customerCounty.toLowerCase();
        const state = self.state.customerState.toLowerCase();
        const country = self.state.customerCountryCode.toLowerCase();

        const hasNull = self.zipCodes.filter((i) => i === "null").length;
        const zipcodeMap = self.zipCodes
          .filter((i) => i !== "null" && i !== "")
          .map((i) => `${i}`.toLowerCase())
          .filter((i) => {
            return `${postalCode}`.indexOf(i) !== -1;
          });

        if (!zipcodeMap.length && !hasNull) {
          return "zip-not-serviced";
        }
        const donttax =
          self?.dontTaxZipCodes && Array.isArray(self.dontTaxZipCodes)
            ? self.dontTaxZipCodes
            : [];

        if (postalCode && donttax.includes(postalCode)) {
          self.serviceTax = 0.0;
          self.lookupZipCodeTax = false;
        } else {
          if (self.lookupZipCodeTax) {
            self.lookupPostalTaxRate({
              street,
              city,
              postalCode,
              county,
              state,
              country,
            });
          }
        }

        if (self.crmSolution !== "real-green") {
          return "ask-address-line2-needed";
        }
        return "looking-up-property";
      },
    },
    {
      id: "ask-address-line2-needed",
      message: "Is there an apartment, unit or suite number?",
      trigger: "collect-address-line2-needed",
    },
    {
      id: "collect-address-line2-needed",
      component: (
        <PrettyButtonGroup
          step={this}
          self={self}
          buttons={[
            {
              value: "Yes",
              label: "Yes",
              icon: <ThumbUpSharp />,
              style: {
                backgroundColor: "white",
                color: "#1565C0",
                borderRadius: "24px",
                padding: "10px 20px",
                fontSize: "16px",
                minWidth: "150px",
                marginRight: "20px",
              },
            },
            {
              value: "No",
              label: "No",
              icon: <ThumbDown />,
              style: {
                backgroundColor: "#1565C0",
                color: "white",
                borderRadius: "24px",
                padding: "10px 20px",
                fontSize: "16px",
                minWidth: "150px",
                marginRight: "20px",
              },
            },
          ]}
        />
      ),
      asMessage: false,
      waitAction: true,
      setVariable: "Apartment.Suite.Unit.Number",
      trigger: () => {
        if (self.answers["Apartment.Suite.Unit.Number"] === "Yes") {
          return "ask-address-line2";
        }
        return "looking-up-property";
      },
    },
    {
      id: "ask-address-line2",
      message: "Please enter the apartment, unit or suite number",
      trigger: "collect-address-line2",
    },
    {
      id: "collect-address-line2",
      component: (
        <InlineUserInput
          id="new-customer-address-line2"
          placeholder={"Apartment, Unit or Suite Number"}
          type={"text"}
          customButton={true}
          defaultInputMessage={"Send"}
          validator={(value) => {
            if (value.trim() === "") {
              return "Apartment, Unit or Suite Number is Required";
            }
            return true;
          }}
        />
      ),

      waitAction: true,
      sendUserMessage: true,
      dispatchMessage: (val) => {
        if (val && val !== "null") {
          self.setState({ customerAddress2: val });
          // self.recordChatRecord({customerName: val});

          // Save quote data to localStorage after updating address line 2
          self.saveQuoteToLocalStorage();
        }
      },
      trigger: "looking-up-property",
    },
    {
      id: "new-customer-address-ask",
      message: `Great! We have many customers in {previousValue}.
      
          Please enter your street address
           
          
          Example. (7890 Main St) `,
      trigger: "collect-new-customer-address",
    },
    {
      id: "looking-up-property",
      component: (
        <NoInputComponent
          dispatchMessage={async () =>
            await self.lookupEstimateFromSources({
              customerAddress: self.state.customerAddress,
            })
          }
          disappearAfter={true}
          asHTML={true}
          showLoading={true}
          message={`<div style="color: #ccc; font-size: 18px; margin-top:10px;">We are looking up information on your property... please wait.</div>`}
        />
      ),
      asMessage: false,
      waitAction: true,
      trigger: () => {
        if (self.hideArielAndStreetView) {
          return "ask-email";
        }
        const totalLotSize = self.state.totalLotSize;
        if (self.sqftEstimateSource === "measur-it") {
          return "show-customer-aerial";
        }
        if (totalLotSize || self.botType === "pest") {
          return "show-customer-aerial";
        }
        return "well-thanks-anyway";
      },
    },
    {
      id: "square-footage-cant-find",
      message:
        "We couldn't find any information on your internal square footage from our sources.",
      trigger: "manual-square-footage-ask",
    },
    {
      id: "manual-square-footage-ask",
      message: "Please enter your house's square footage below.",
      trigger: "enter-manual-square-footage",
    },
    {
      id: "enter-manual-square-footage",
      component: (
        <InlineUserInput
          id="new-customer-square-footage"
          validator={(value) => {
            const trimmedValue = `${value}`.toLowerCase().trim();
            if (
              trimmedValue.length < 1 ||
              trimmedValue.includes("e") ||
              // biome-ignore lint/suspicious/noGlobalIsNan: This is required
              isNaN(value)
            ) {
              return "Please input only numeric values.";
            }
            if (Number.parseFloat(value) <= 0) {
              return "Square footage must be greater than zero.";
            }
            return true;
          }}
          placeholder={"Internal Square Footage"}
          type="number"
        />
      ),
      waitAction: true,
      trigger: ({ value }) => {
        const squareFootage = Number.parseFloat(value);

        if (
          !self.skipMeasurement &&
          (squareFootage < self.companyMinQuotableSize ||
            squareFootage > self.companyMaxQuotableSize)
        ) {
          self.setState({
            estimate: squareFootage,
          });

          // Delay by 2 seconds to ensure state is set before saving
          setTimeout(() => {
            self.saveQuoteToLocalStorage();
          }, 2000);

          return "well-thanks-anyway";
        }

        // Store the square footage for the next step
        self.pendingSquareFootage = squareFootage;

        // Return the state update step
        return "update-square-footage-state";
      },
    },
    {
      id: "update-square-footage-state",
      component: (
        <NoInputComponent
          dispatchMessage={async () => {
            await self.setState({
              totalLotSize: self.pendingSquareFootage,
              adjustedLotSize: self.pendingSquareFootage,
              estimate: self.pendingSquareFootage,
            });

            // Save quote data to localStorage after updating square footage
            self.saveQuoteToLocalStorage();
          }}
          disappearAfter={true}
          asHTML={true}
          showLoading={true}
          message="Updating property information..."
        />
      ),
      asMessage: false,
      waitAction: true,
      trigger: () => {
        // Check for probing questions first
        if (self.preModalQuestions?.length > 0) {
          return "pre-modal-entry";
        }

        // Then check for mandatory service questions
        const { selectedPrograms } = self.state;
        const mandatoryServiceQuestionsPrograms =
          getMandatoryServiceQuestionsProgramTypes();
        if (
          selectedPrograms.some((program) =>
            mandatoryServiceQuestionsPrograms.includes(program),
          )
        ) {
          return self.startServiceQuestions();
        }

        // Finally check for regular program questions
        const questions = selectedPrograms
          .map((i) => {
            const entry = `${getServiceEntryId(i)}-entry`;
            const item = self.state.steps.find((t) => t.id === entry);
            return item;
          })
          .filter((p) => p);

        if (questions.length) {
          // Check if any selected program has probing questions enabled
          // Only ACTIVE programs with useProbingQuestions: true should show customization options
          const hasCustomizablePrograms = selectedPrograms.some((program) =>
            hasProbingQuestionsEnabled(program, self.programDetails),
          );

          // If no active programs have probing questions enabled,
          // skip directly to calculating the quote
          if (!hasCustomizablePrograms) {
            self.updateCalculatingStep();
            return "no-questions-open-quote";
          }

          return "ask-quote-now";
        }

        // If no questions, proceed to quote calculation
        self.updateCalculatingStep();
        return "no-questions-open-quote";
      },
    },
    {
      id: "updating-state",
      message: "Calculating your quote...",
      trigger: "no-questions-open-quote",
    },
    {
      id: "congrats-sale",
      message: "Congratulations!",
      trigger: () => {
        self.purchaseMade = true;
        return "sales-party";
      },
    },
    {
      id: "sales-party",
      component: <HtmlMessageComponent />,
      inputAttributes: {
        html: "<img src='/assets/images/party.gif' alt='congrats on sale' width='100%' />",
      },
      trigger: "service-questions-entry",
    },
    {
      id: "zip-not-serviced",
      message:
        "It appears we are unable to quote your property; the address provided is outside our service area.",
      end: true,
    },
    {
      id: "sqft-too-big",
      message:
        "Our instant quote technology is good, however we feel it would be best for us to manually review your property with you. We'll be in touch soon.",
      end: true,
    },
  ];
}
